define('controllers/latestevents',['require','johngrid'],function (require) {
    var CreateJohnGrid = require('johngrid');
    return function() {
        $(function () {
            $(".seeMoreEvents, .showSingle").on("click", function (e) {
                e.preventDefault();

                var $this = $(this),
                    EventContainer = $this.parent().parent(),
                    singleEvent = $(".singleEvent", EventContainer),
                    manyEvents = $(".manyEvents", EventContainer);

                showMultiple = $this.hasClass("seeMoreEvents");

                if (showMultiple) {
                    var loading = $("<span class='sideNote'>Loading...</span>"),
                        requestMethod = EventContainer.attr("data-requestMethod");

                    loading.insertAfter($this);
                    $this.hide();

                    $.post("/myaccount/accountsummary/transactionsAJAX.aspx", { method: requestMethod }, function (response) {
                        Utilities.handleAJAXResponse(response, function (latestEvents) {
                            var table = $("table", manyEvents),
                                grid = CreateJohnGrid(),
                                columns = [{ DataField: "Amount" }, { DataField: "Bank" }, { DataField: "BatchDate", HeaderText: "Event Date" }];

                            grid.init(table, columns);
                            grid.databind(latestEvents);

                            loadedMultiple = true;
                            loading.remove();
                            $this.show();
                            singleEvent.hide();
                            manyEvents.show();
                        },
                        function (error) {
                            $this.text(error).addClass("alert").addClass("alert-error").show();
                        });
                    });
                } else {
                    singleEvent.show();
                    manyEvents.hide();
                }
            });
        });
    };
});

